import React, { Component } from 'react';
import { Button, Modal, Form, Spin, Input } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { actions } from "store";
import { FormItem } from "utils";
import { Error } from "components/common";
import ServiceGroupSelect from '../ServiceGroupSelect';


class ServiceForm extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { actions, service } = this.props;
        const instance = service.editObject;

        let data = Object.assign({}, values);
        if (instance && instance.id) {
          data.id = instance.id;
        }
        actions.serviceUpdate(data);
      }
    });
  };

  close = () => {
    const { actions } = this.props;
    actions.serviceShowEditForm({ show: false });
  };

  render() {
    const { form, service } = this.props;
    const { showEditForm, updateStatus, editObject } = service;
    const instance = editObject;

    const error = updateStatus.error || {};
    const errorData = error.data || {};

    const isLoading = service.updateStatus.isLoading;

    return (
      <Modal
        visible={showEditForm}
        title="Редактирование услуги"
        onCancel={this.close}
        maskClosable={false}
        destroyOnClose={true}
        footer={[
          <Button key="cancel" onClick={this.close} disabled={isLoading}>Отмена</Button>,
          <Button key="submit" type="primary" loading={isLoading} onClick={this.handleSubmit}>
            Сохранить
          </Button>,
        ]}
      >
        <Spin spinning={isLoading}>
          <Form onSubmit={this.handleSubmit}>
            <Error errors={errorData.non_field_errors}/>

            <ServiceGroupSelect
              form={form}
              instance={instance}
              name="group"
              label="Группа"
              placeholder="Выберите группу"
              required={true}
              errorData={errorData}
            />

            <FormItem
              form={form}
              instance={instance}
              name="name"
              label="Название"
              required={true}
              errorData={errorData}

            >
              <Input size="large"/>
            </FormItem>

            <FormItem
              form={form}
              instance={instance}
              name="sort"
              label="Сортировка"
              required={true}
              errorData={errorData}

            >
              <Input size="large"/>
            </FormItem>
          </Form>
        </Spin>
      </Modal>
    );
  }
}


const WrappedServiceForm = Form.create()(ServiceForm);

function mapStateToProps(state) {
  return {
    service: state.service,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.service), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WrappedServiceForm);

